import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { DropDownValue, Field } from '../../models/entity-defin';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import * as _ from 'lodash-es';
import { DropDownPagingInput } from 'src/app/models/drop-down-paging-input';

@Component({
  selector: 'app-pcedit-modal',
  templateUrl: './pcedit-modal.component.html',
  styleUrls: ['./pcedit-modal.component.css'],
})
export class PCEditModalComponent implements OnChanges {
  constructor(
    private logger: LoggerService,
    private renderer: Renderer2,
    private apiService: UserApiService,
    private modalService: NgbModal
  ) {

    this.renderer.listen('window', 'keyup', (e: any) => {
      if (this.modalIsOpen) {
        if (e.key == 'Enter') {
          this.submitModal();
          return;
        }

        if (e.key == 'ESC') {
          this.modalContent.dismiss('Cross click');
          return;
        }
      }
    });
  }

  public shakeFrom: boolean = false;
  public monthName: string = '';
  public modalTitle: string = '';
  public thisValue: any;

  public fields: Field[] = [];

  @Input() editSource: any;
  @Input() modalIsOpen?: boolean;
  @Input() inputFields?: Field[];

  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;
  @ViewChild('modalContent') modalContent!: any;

  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  public countryDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Country',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public checkValidation(item: Field): boolean {
    try {
      if (item.fieldType == 'Boolean') {
        if (
          item.defaultValue != true &&
          item.defaultValue != false &&
          item.isMandatory
        ) {
          item.message = 'Required';
          item.isInvalid = true;
          return false;
        } else {
          item.message = '';
          item.isInvalid = false;
          return true;
        }
      }
      if (
        item.isMandatory &&
        (item.defaultValue == null || item.defaultValue == '')
      ) {
        item.message = 'Required';
        item.isInvalid = true;
        return false;
      }

      if (item.validationPattern == null || item.validationPattern == '') {
        item.message = '';
        item.isInvalid = false;
        return true;
      }

      let regex = new RegExp(item.validationPattern);
      if (item.defaultValue.match(regex) == null) {
        item.message = 'invalid_Pattern';
        console.log('Invalid Pattern is : ' + item.validationPattern);
        item.isInvalid = true;
        return false;
      }

      item.message = '';
      item.isInvalid = false;
      return true;
    } catch (error) {
      this.logger.addClientException(error, 'checkValidation');
      return false;
    }
  }

  public fullValidation(): boolean {
    if (this.fields == null) {
      return false;
    }

    this.fields.forEach((element) => {
      this.checkValidation(element);
    });

    const isNotValid = this.fields.filter(
      (current) => current.isInvalid == true
    );

    if (isNotValid.length == 0) {
      return true;
    }

    return false;
  }

  public checkEditValidation(item: any): boolean {
    try {
      var isValid = true;
      for (let index = 0; index < item.length; index++) {
        let element = item[index];

        let idRegex = new RegExp(/(^id[A-Z]{1})|(^Id[A-Z]{1})|(id$)|(Id$)/);
        if (element.fieldName.match(idRegex)) {
          let guidRegex = new RegExp(
            /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/
          );

          if (!element.defaultValue.match(guidRegex)) {
            element.hint = 'این فیلد اجباری می باشد';
            isValid = false;
          } else {
            element.hint = undefined;
          }
          continue;
        }

        if (element.noEditable == true) {
          continue;
        }

        if (
          element.fieldType == 'boolean' &&
          (element.defaultValue == null || element.defaultValue == '')
        ) {
          element.defaultValue = false;
          continue;
        }
        if (element.isMandatory) {
          if (element.defaultValue == null || element.defaultValue == '') {
            isValid = false;
            element.hint = 'این فیلد اجباری می باشد';
            continue;
          } else {
            element.hint = null;
          }
        } else {
          if (element.defaultValue == null || element.defaultValue == '') {
            element.hint = null;
            continue;
          }
        }

        if (element.pattern == null) {
          element.hint == null;
          continue;
        }

        let exactMatch = new RegExp(element.pattern);
        if (!exactMatch.test(element.defaultValue)) {
          element.hint = 'فرمت ورود اطلاعات صحیح نیست';
          isValid = false;
        } else {
          element.hint = null;
        }
      }
      return isValid;
    } catch (error) {
      this.logger.addError('خطایی در اعتبارسنجی فرم اتفاق افتاده است', false);
      return false;
    }
  }

  public checkInvalidCount() {
    try {
      var foundedError = this.thisValue.filter(
        (current) => current.isInvalid == true
      );
      if (foundedError.length > 0) {
        this.shakeFrom = true;
      } else {
        this.shakeFrom = false;
      }
    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public openModal() {
    try {
      this.modalService
        .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
              this.callParent('Save', this.thisValue);
            }

            this.callParent('Close', null);
          },
          (reason) => {
            this.callParent('Close', null);
          }
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    try {
      if (
        changes &&
        changes['modalIsOpen'] &&
        changes['modalIsOpen'].currentValue !== undefined
      ) {
        if (changes['modalIsOpen'].currentValue == true) {
          this.openModal();
        } else if (changes['modalIsOpen'].currentValue == false) {
          this.modalService.dismissAll();
        }
      }
      if (
        changes &&
        changes['inputFields'] &&
        changes['inputFields'].currentValue !== undefined &&
        changes['editSource'] == undefined
      ) {
        if (changes['inputFields'].currentValue.length > 0) {
          this.initPage();
        }
      }
      if (changes && changes['editSource']) {
        if (changes['editSource'].currentValue !== undefined) {
          if (this.inputFields) {
            this.fields = _.cloneDeep(this.inputFields);
            for (let index = 0; index < this.fields.length; index++) {
              const element = this.fields[index];
              if (element.isRelational) {
                this.getData(element);
              }
              element.defaultValue =
                this.editSource[this.titleCaseWord(element.fieldName)];
            }
          }
        } else {
          if (this.inputFields) {
            this.fields = _.cloneDeep(this.inputFields);
          }
        }
      }
    } catch (error) {
      this.logger.addClientException(error, 'checkValidation');
    }
  }

  public callParent(action: string, data: any) {
    this.parentAction.next(new PCTableOutputModel(action, data));
  }

  public titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toLowerCase() + word.substr(1);
  }

  public submitModal() {
    if (this.editSource == null || this.editSource == undefined) {
      if (this.fullValidation()) {
        this.callParent('SaveAdd', this.fields);
      }
    } else {
      if (this.fullValidation()) {
        this.callParent('SaveEdit', this.fields);
      }
    }
  }

  public initPage() {
    try {
      this.fields = this.inputFields!.sort((current) => current.order);

      this.fields.forEach((element) => {
        if (
          element.fieldType == 'Boolean' &&
          (element.defaultValue != true || element.defaultValue != false)
        ) {
          element.defaultValue = false;
        }

        if (element.isRelational) {
          this.getData(element);
        }
      });
    } catch (error) {
      this.logger.addClientException(error, 'initPage');
    }
  }

  public getData(element: Field) {
    try {
      const url = `${element.fieldType}?pageNumber=1&pageSize=1000&paging=false&orderBy=&direction=&search=`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      element.defaultValue = '';
      const propertyKey = this.apiService.camelCase(element.propertyKey);

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            element.dropDownValue = result.data?.map((current) => ({
              key: current.id,
              value: current[propertyKey],
            }));
            element.defaultValue =
              this.editSource[this.titleCaseWord(element.fieldName)];
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
    } catch (error) {
      this.logger.addClientException(error, 'checkValidation');
    }
  }
}
